import React from 'react';
import { LayoutAnimation } from 'react-native';
import { Button } from "../../native";
import * as R from 'unitx/ramda';
import { useFormContext } from "./FormContext";
export default (props => {
  const {
    arrayAddTitle
  } = useFormContext();
  const {
    onPress,
    disabled
  } = props;
  return /*#__PURE__*/React.createElement(Button, {
    onPress: R.pipe(R.tap(() => LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut)), onPress),
    disabled: disabled
  }, arrayAddTitle);
});